<template>
  <div class="min-h-screen lg:ml-56 lg:mr-44">
    <!-- HEADING -->
    <div class="lg:h-72 flex justify-start items-end p-12 bg-gray-200">
      <div
        class="h-32 border-l-4 pl-6 border-black flex flex-col justify-end items-end m-0 p-0 w-full"
      >
        <h1
          v-if="resource.id"
          class="w-full text-left flex justify-start items-center"
        >
          <svg
            v-if="resource.type === 3"
            xmlns="http://www.w3.org/2000/svg"
            class="h-16 w-16"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-if="resource.type === 2"
            xmlns="http://www.w3.org/2000/svg"
            class="h-16 w-16"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <svg
            v-if="resource.type === 1"
            xmlns="http://www.w3.org/2000/svg"
            class="h-16 w-16"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
          <span class="capitalize">{{ resource.title }}</span>
        </h1>
      </div>
    </div>

    <!-- CONTENT -->
    <div
      class="bg-bluegray-700 w-full pb-16 flex flex-col items-center lg:items-start"
    >
      <h5
        class="flex text-white items-center ml-4 lg:ml-16 mt-4 lg:mt-16 mt-auto cursor-pointer"
        @click="goToResources"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M7 16l-4-4m0 0l4-4m-4 4h18"
          />
        </svg>
        Back to resources
      </h5>

      <div
        class="bg-white min-h-screen rounded-xl lg:ml-16 mt-16 w-11/12 lg:w-9/12"
      >
        <div
          v-if="resource.id"
          :class="loaded ? 'py-16 px-6 lg:p-16' : ''"
          class="relative z-20 flex flex-col flex-wrap lg:flex-nowrap"
        >
          <div>
            <button
              :disabled="thinking"
              type="submit"
              :class="[
                thinking
                  ? 'bg-red-600 hover:bg-red-600 cursor-not-allowed'
                  : '',
              ]"
              class="relative btn btn ml-auto w-40 bg-red-600 border border-red-600 text-white hover:bg-white hover:text-red-600 active:bg-red-600 active:text-white focus:bg-red-600 focus:text-white"
              @click="deleteResource"
            >
              <div
                class="absolute inset-0 w-full flex justify-center items-center z-20"
              >
                <lottie v-if="thinking" :options="loadingAnimationOptions" />
              </div>
              <span :class="[thinking ? 'invisible' : '']">Delete</span>
            </button>
          </div>

          <div class="lg:flex">
            <!-- IMAGE PREVIEW -->
            <div v-if="resource.type === 2" class="w-full lg:w-1/3">
              <img
                v-if="resource.type === 2"
                class="mb-4"
                :src="resource.file_url"
              />
            </div>

            <!-- FILE DETAILS -->
            <div
              :class="[resource.type === 2 ? 'w-full lg:w-2/3 pl-8' : 'w-full']"
              class="space-y-8 flex flex-col"
            >
              <!-- VIDEO -->
              <div
                :class="
                  resource.type === 3 ? 'space-x-4' : 'flex-col space-y-4'
                "
                class="w-full flex"
              >
                <div
                  v-if="resource.type === 3"
                  class="w-full flex flex-col space-y-1"
                >
                  <div
                    v-show="!update_video"
                    style="height: 300px; width: 419px"
                  >
                    <iframe
                      v-show="original_show_video_preview && !update_video"
                      ref="resourceVideoPreview"
                      type="iframe"
                      aspect="16by9"
                      :src="original_show_video_preview"
                      frameborder="0"
                      style="height: 300px; width: 419px"
                    ></iframe>
                  </div>

                  <div
                    v-if="update_video"
                    class="flex flex-col space-y-2 w-full"
                  >
                    <iframe
                      v-if="show_video_preview"
                      ref="resourceVideoPreview"
                      type="iframe"
                      aspect="16by9"
                      class="inset-0 w-full h-full"
                      :src="show_video_preview"
                      frameborder="0"
                      style="height: 300px; width: 419px"
                    ></iframe>

                    <div
                      v-if="show_video_preview"
                      class="w-full flex space-x-1 h-12 items-center justify-start"
                    >
                      <button
                        :disabled="!show_video_preview"
                        type="button"
                        :class="[
                          !show_video_preview
                            ? 'opacity-50 cursor-not-allowed'
                            : '',
                        ]"
                        class="py-4 px-10 rounded-md text-sm leading-4 font-medium text-white hover:bg-black bg-primary transition-all duration-100 ease-in-out"
                        @click="save_video"
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        class="py-2 px-3 rounded-md text-sm leading-4 font-medium hover:text-red-700 text-red-500 transition-all duration-100 ease-in-out"
                        @click="goToResources"
                      >
                        Cancel
                      </button>
                    </div>

                    <div v-if="!show_video_preview" class="w-full">
                      <div class="flex flex-col w-full mb-8">
                        <h5 class="mb-4">Select your platform</h5>
                        <div class="flex mb-4 relative">
                          <button
                            type="button"
                            class="inline-flex items-center cursor-pointer mr-4"
                            @click="video_type = 'YouTube'"
                          >
                            <span
                              :class="
                                video_type === 'YouTube'
                                  ? 'font-semibold text-primary'
                                  : ''
                              "
                              class="ml-1"
                              >YouTube</span
                            >
                          </button>

                          <div
                            class="w-px relative top-0.5 h-4 bg-bluegray-300 mr-4"
                          ></div>

                          <button
                            type="button"
                            class="inline-flex items-center cursor-pointer mr-4"
                            @click="video_type = 'Vimeo'"
                          >
                            <span
                              :class="
                                video_type === 'Vimeo'
                                  ? 'font-semibold text-cyan-400'
                                  : ''
                              "
                              class="ml-1"
                              >Vimeo</span
                            >
                          </button>

                          <div
                            :class="[
                              video_type === 'YouTube'
                                ? 'bg-expo_red translate-x-0'
                                : 'bg-cyan-400 translate-x-130',
                            ]"
                            class="absolute h-1 left-1 top-full transform translate-y-2 w-16 transition-all duration-300 ease-in-out rounded"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="h-12 w-52 rounded relative bg-white shadow border border-bluegray-300 flex-shrink-0"
                      >
                        <h6
                          :class="inputLabelClass"
                          class="flex items-center group"
                        >
                          {{ video_type }} video id
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-3 w-3 ml-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <div :class="infoClass">
                            Only insert the {{ video_type }} video ID number or
                            code example "108799588" or "GCHLt0NDkdY"
                          </div>
                        </h6>
                        <input
                          id="post_link_title"
                          v-model="video_code"
                          type="text"
                          name="post_link_title"
                          autocomplete="post_link_title"
                          :class="inputTextClass"
                        />
                      </div>

                      <div class="w-full flex space-x-1 mt-4">
                        <button
                          v-if="!show_video_preview"
                          type="button"
                          class="py-2 px-3 rounded-md text-sm leading-4 font-medium text-white hover:bg-black bg-primary transition-all duration-100 ease-in-out"
                          @click="preview_video"
                        >
                          Preview
                        </button>
                        <button
                          v-if="show_video_preview"
                          type="button"
                          class="py-2 px-3 rounded-md text-sm leading-4 font-medium text-white hover:bg-black bg-primary transition-all duration-100 ease-in-out"
                          @click="save_video"
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          class="py-2 px-3 rounded-md text-sm leading-4 font-medium hover:text-red-700 text-red-500 transition-all duration-100 ease-in-out"
                          @click="reset(true)"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- RESOURCE NAME CHANGE -->
                <div
                  v-if="!update_video"
                  class="w-full"
                  :class="
                    resource.type === 3
                      ? 'space-y-2'
                      : 'flex flex-col space-y-1'
                  "
                >
                  <h5 class="mb-2">Update title</h5>
                  <div v-if="!file_new_title_update" class="text-gray-500">
                    {{ resource.title }}
                  </div>
                  <div class="w-full">
                    <div
                      v-if="!file_new_title_update"
                      class="flex items-center"
                    >
                      <button
                        v-if="!file_new_title_update"
                        type="button"
                        class="btn btn-trans-black px-4 py-2 m-0 active:text-black"
                        @click="file_new_title_update = !file_new_title_update"
                      >
                        Edit title
                      </button>
                    </div>
                    <div
                      v-if="file_new_title_update"
                      class="relative flex items-start"
                    >
                      <div class="w-full max-w-xl flex flex-col space-y-1">
                        <div
                          :class="
                            resource.type === 3
                              ? 'space-y-2 flex-col'
                              : 'items-center space-x-2'
                          "
                          class="flex w-full"
                        >
                          <div class="w-full">
                            <input
                              id="file_new_title"
                              v-model="file_new_title"
                              :placeholder="resource.title"
                              type="text"
                              name="file_new_title"
                              autocomplete="file_new_title"
                              class="border rounded"
                              :class="inputTextClass"
                            />
                          </div>
                          <div class="ml-auto">
                            <button
                              type="button"
                              class="p-3 rounded-md text-sm leading-4 font-medium hover:text-red-700 text-red-500 transition-all duration-100 ease-in-out"
                              @click="goToResources"
                            >
                              Cancel
                            </button>
                            <button
                              :disabled="file_new_title_disabled"
                              type="button"
                              :class="[
                                file_new_title_disabled
                                  ? 'opacity-25 cursor-not-allowed'
                                  : '',
                              ]"
                              class="p-3 rounded-md text-sm leading-4 font-medium text-white hover:bg-black bg-primary transition-all duration-100 ease-in-out"
                              @click="update_file_title()"
                            >
                              Submit
                            </button>
                          </div>
                          <div v-if="resource.type === 3" class="w-full">
                            <button
                              type="button"
                              class="btn btn-black lg:relative lg:top-2 lg:ml-auto 2xl:ml-0 lg:mt-28 px-4 py-2 m-0 active:text-black"
                              @click="update_video = !update_video"
                            >
                              <span>Change video</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- FILE RESOURCE -->
                <div
                  v-if="resource.type === 2"
                  class="w-full flex flex-col space-y-1"
                >
                  <h5>File:</h5>
                  <div v-if="!file_new_preview" class="text-gray-500">
                    {{ resource.file }}
                  </div>
                  <div v-if="file_abort_error" class="text-red-700">
                    Please select the correct file format...
                  </div>
                  <!-- NEW FILE UPLOAD -->
                  <div class="w-full">
                    <div class="flex items-center">
                      <button
                        v-if="!file_new_preview_change"
                        type="button"
                        class="btn btn-trans-black px-4 py-2 m-0 active:text-black"
                        @click="file_new_change"
                      >
                        Replace file
                      </button>
                      <form ref="selectFileForm">
                        <input
                          ref="selectFile"
                          type="file"
                          class="hidden"
                          @input="file_new_selected"
                        />
                      </form>
                    </div>
                    <div
                      v-if="file_new_preview"
                      class="relative flex items-start"
                    >
                      <!-- Custom file Title -->
                      <div class="w-full flex flex-col space-y-1">
                        <h6 class="text-sm">
                          Replace with
                          <span class="font-semibold">{{
                            file_new_file_title
                          }}</span>
                        </h6>
                        <div class="w-full flex items-center space-x-2">
                          <button
                            type="button"
                            class="btn btn-trans-black px-4 py-2 m-0 active:text-black"
                            @click="update_file()"
                          >
                            Submit
                          </button>
                          <button
                            v-if="file_new_preview_change"
                            type="button"
                            class="btn btn-trans-black px-4 py-2 m-0 active:text-black"
                            @click="file_new_reset"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="resource.type === 1"
                class="mt-12 mb-6 btn btn-black w-40"
              >
                <a
                  target="_blank"
                  class="hover:text-black"
                  :href="resource.file_url"
                  >Download</a
                >
              </div>
              <button
                v-if="resource.type === 1"
                :disabled="thinking"
                type="submit"
                :class="[
                  thinking
                    ? 'bg-red-600 hover:bg-red-600 cursor-not-allowed btn border border-red-600 text-white'
                    : 'font-primary underline text-p cursor-pointer font-semibold text-red-600',
                ]"
                class="relative"
                @click="deleteResource"
              >
                <div
                  class="absolute inset-0 w-full flex justify-center items-center z-20"
                >
                  <lottie v-if="thinking" :options="loadingAnimationOptions" />
                </div>
                <span :class="[thinking ? 'invisible' : '']"
                  >Delete Permanently</span
                >
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="!loaded"
          class="w-full rounded-xl min-h-screen flex flex-col items-center bg-bluegray-300 p-16"
        >
          <div class="mt-16 w-32">
            <lottie :options="loadingAnimationOptions" />
            <span class="text-white text-center">Loading Media</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {},

  props: {
    resource_id: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      thinking: false,
      loaded: false,

      infoClass:
        'absolute left-full top-0 w-64 z-50 border border-bluegray-300 rounded p-4 opacity-0 transition-all duration-300 transform pointer-events-none shadow group-hover:opacity-100 bg-white',
      inputTextClass:
        'flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-bluegray-300',
      inputLabelClass:
        'absolute transform duration-100 ease-linear px-1 left-3 top-1 z-40 text-bluegray-700',
      inputWrapperClass:
        'rounded relative bg-white shadow border border-bluegray-300 mb-8 ',

      resource: {},

      // Add a new resource file...
      file_new_file: null,
      file_new_file_title: null,
      file_new_preview: null,
      file_new_preview_change: false,
      file_abort_error: false,
      file_new_type: 0,

      file_new_title_update: true,
      file_new_title: '',
      file_new_title_disabled: true,

      // Video
      video_code: null, // model
      show_video_preview: null,
      video_type: 'YouTube',
      video_types: [
        { value: 'YouTube', text: 'YouTube' },
        { value: 'Vimeo', text: 'Vimeo' },
      ],

      update_video: false,
      original_video_code: null, // model
      original_show_video_preview: null,
      original_video_type: 'YouTube',

      // Pagination
      pagination: {
        current_page: null,
        total_pages: null,
        per_page: 9,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },
    }
  },

  watch: {
    file_new_title: {
      // image option
      handler: function (val) {
        if (val.length < 1) {
          this.$set(this, 'file_new_title_disabled', true)
        } else {
          this.$set(this, 'file_new_title_disabled', false)
        }
      },

      deep: true,
    },

    resource: {
      handler: function (resource) {
        if (resource.type === 3) {
          this.$set(this, 'original_video_code', resource.video_code)
          this.$set(this, 'original_video_type', resource.video_type)

          let src = false
          if (resource.video_type === 'YouTube') {
            src = 'https://www.youtube.com/embed/' + resource.video_code
          }
          if (resource.video_type === 'Vimeo') {
            src = 'https://player.vimeo.com/video/' + resource.video_code
          }
          this.$set(this, 'original_show_video_preview', src)

          this.$set(this, 'original_video_code', resource.video_code)
          this.$set(this, 'original_video_type', resource.video_type)
        }
      },

      deep: true,
    },

    update_video: {
      handler: function () {
        this.reset()
      },

      deep: true,
    },
  },

  mounted() {
    if (this.resource_id) {
      this.getResource()
    }
  },

  methods: {
    preview_video() {
      if (!this.video_code) {
        return
      }

      let src = false
      if (this.video_type === 'YouTube') {
        src = 'https://www.youtube.com/embed/' + this.video_code
      }
      if (this.video_type === 'Vimeo') {
        src = 'https://player.vimeo.com/video/' + this.video_code
      }

      this.$set(this, 'show_video_preview', src)
    },

    video_url_format(code) {
      if (!code) {
        return
      }

      if (this.video_type === 'YouTube') {
        let str = code.replace('//www.youtube.com/embed/', '')
        this.resourceVideoEmbedUrl = '//www.youtube.com/embed/' + str
        code = str
      }

      if (this.video_type === 'Vimeo') {
        let str = code.replace('//player.vimeo.com/video/', '')
        this.resourceVideoEmbedUrl = '//player.vimeo.com/video/' + str
        code = str
      }

      return code
    },

    save_video() {
      // confirm('saving new resource')
      this.thinking = true

      axios
        .post('/api/auth/update-resource-video', {
          video_code: this.video_code,
          video_type: this.video_type,
          resource_id: this.resource,
        })
        .then((response) => {
          let result = response.data
          if (result.success && result.resource) {
            this.$set(this, 'resource', result.resource)
          }
          this.reset(true)
          if (response.data.alert) {
            this.thinking = false
            EventBus.$emit('triggerAlertResponse', response.data.alert)
          }
        })
    },

    reset(all = false) {
      this.$set(this, 'video_type', 'YouTube')
      this.$set(this, 'video_code', null)
      this.$set(this, 'show_video_preview', null)

      if (all) {
        this.$set(this, 'update_video', false)
      }
    },

    deleteResource() {
      this.$set(this, 'thinking', true)
      if (!this.resource.id) {
        return
      }
      axios
        .get('/api/auth/delete-resource/' + this.resource.id)
        .then((response) => {
          this.$set(this, 'thinking', false)
          if (response.data.success) {
            this.$router.push({ name: 'Resources' })
          }
          if (response.data.alert) {
            EventBus.$emit('triggerAlertResponse', response.data.alert)
          }
        })
    },

    file_new_reset() {
      this.$set(this, 'file_new_preview_change', false)
      this.$set(this, 'file_new_preview', null)
      this.$set(this, 'file_new_file', null)
      this.$set(this, 'file_new_type', 0)
      this.$set(this, 'file_abort_error', false)
    },

    file_new_change() {
      this.$refs.selectFile.click()
    },

    file_new_selected() {
      let input = this.$refs.selectFile
      let file = input.files
      // Determine if we have the correct file format and categorise it's type for upload...
      let document_formats =
        /(\.doc|\.docx|\.odt|\.pdf|\.tex|\.txt|\.rtf|\.wps|\.wks|\.wpd)$/i
      let image_formats = /(\.png|\.jpg|\.jpeg)$/i
      let type = 0
      if (document_formats.exec(file[0].name)) {
        type = 1
      }
      if (image_formats.exec(file[0].name)) {
        type = 2
      }
      if (type < 1) {
        this.$set(this, 'file_abort_error', true)
        return
      }
      this.$set(this, 'file_abort_error', false)
      if (file && file[0]) {
        if (file[0].size > 1024 * 1024 * 2) {
          EventBus.$emit('triggerAlertResponse', {
            status: 'error',
            message: 'File size too large. 2mb file size limit exceeded.',
          })
          return
        }

        let reader = new FileReader()
        reader.onload = () => {
          this.$set(this, 'file_new_preview_change', true)
          this.$set(this, 'file_new_preview', file[0])
          this.$set(this, 'file_new_type', type)
          this.$set(
            this,
            'file_new_file_title',
            file[0].name.split('.').slice(0, -1).join('.'),
          )
        }
        reader.readAsDataURL(file[0])
        this.$emit('input', file[0])
      }
    },

    update_file_title() {
      let submitData = new FormData()
      submitData.append('resource_title', this.file_new_title)
      submitData.append('resource_id', this.resource_id)
      axios
        .post('/api/auth/update-resource-title', submitData)
        .then((response) => {
          let result = response.data
          if (result.success) {
            this.$set(this.resource, 'title', this.file_new_title)
            this.$set(this, 'file_new_title_update', false)
            this.$set(this, 'file_new_title', '')
            this.$set(this, 'file_new_preview_change', false)
          }
          if (response.data.alert) {
            this.thinking = false
            EventBus.$emit('triggerAlertResponse', response.data.alert)
          }
        })
    },

    update_file() {
      let submitData = new FormData()
      submitData.append('resource', this.file_new_preview)
      submitData.append('resource_id', this.resource_id)
      submitData.append('resource_type', this.file_new_type)
      this.file_new_reset()

      axios
        .post('/api/auth/update-resource-file', submitData)
        .then((response) => {
          let result = response.data
          if (result.success) {
            this.$set(this, 'resource', result.resource)
          }
          if (response.data.alert) {
            this.thinking = false
            EventBus.$emit('triggerAlertResponse', response.data.alert)
          }
        })
    },

    getResource() {
      this.$set(this, 'loaded', false)
      let submitData = {}
      submitData.resource_id = this.resource_id
      // Get this post...
      axios.post('/api/auth/resource', submitData).then((response) => {
        this.$set(this, 'loaded', true)
        let result = response.data
        if (result.success) {
          this.$set(this, 'resource', result.resource)
        } else {
          //...
        }
      })
    },

    goToResources() {
      this.$router.push({ name: 'Resources' })
    },
  },
}
</script>
